export default __webpack_public_path__ + "static/media/walldorf.f9244858.jpg";